module.exports = __webpack_public_path__ + "img/notice.3a85170a.jpg";